import { KeyCodes } from '@/consts/keyCodes';

export const isSubmitEvent = (event: React.KeyboardEvent | KeyboardEvent): boolean =>
  !event.shiftKey && event.key === KeyCodes.Enter;
